import { gql, useQuery } from '@apollo/client';

const PONG_QUERY = gql`
    query Pong {
        pong
    }
`;

export default function usePong() {
    const { data, loading, error } = useQuery(PONG_QUERY);
    return {data, loading, error}
}